import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PhxRadioButtonDirective, PhxRadioDirective, PhxRadioTileDirective } from './phx-radio-list.directive';
import { PhxRadioListComponent } from './phx-radio-list.component';
import { PhxRadioItemComponent } from './phx-radio.component';
import { PhxTileModule } from '../tile/phx-tile.module';
import { PhxIconModule } from '../icon/icon.module';

@NgModule({
  declarations: [
    PhxRadioListComponent,
    PhxRadioItemComponent,
    PhxRadioButtonDirective,
    PhxRadioDirective,
    PhxRadioTileDirective,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PhxTileModule,
    PhxIconModule,
  ],
  exports: [
    PhxRadioListComponent,
    PhxRadioItemComponent,
    PhxRadioButtonDirective,
    PhxRadioDirective,
    PhxRadioTileDirective,
  ]
})
export class PhxRadioListModule { }
